/* eslint-disable */
export interface ILoginPage {
  loginSubmitFunction: (username: string, password: string) => Promise<void>
  navigateToForgotPassword: () => void
  errorMessageLogin?: string
}
export enum DSMEnvironments {
  DEV = 'localhost',
  DEV_REMOTE = 'dev-binariidsm-backend.dfaxa.com',
  STAGING = 'main-binariidsm-backend.dswap.io',
  PROD = 'www.binariidsm.app',
  DEMO = 'www.binariidsm.io',
}
